const minusDiscountPercentage = (value: number, percentage: number): number =>
  value - value * (percentage / 100);

export default minusDiscountPercentage;
